import { DashboardModule } from '@domain-group/suit-theme'

import useOrderItemTasks from '@hooks/useOrderItemTasks'

import type { CampaignModel } from '@models/types'

import OrderItemTask from './OrderItemTask'

const OrderItemTasks = (props: { campaign: CampaignModel }) => {
  const { campaign } = props

  const campaignOrderItemTasksPayload = useOrderItemTasks({
    filters: { campaign_id: campaign.id },
    sortBy: 'due_date asc',
  })
  const { filteredOrderItemTasks, hasFilteredOrderItemTasks } = campaignOrderItemTasksPayload

  if (!hasFilteredOrderItemTasks){
    return null
  }

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Tasks"
    >
      {filteredOrderItemTasks.map(orderItemTask => (
        <OrderItemTask key={orderItemTask.id} orderItemTask={orderItemTask} />
      ))}
    </DashboardModule>
  )
}

export default OrderItemTasks
